import styled from "styled-components";
import { devices } from "../../ExternFormEnrollment.styles";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  @media ${devices.tablet} {
    gap: 16px;
  }
`;

export const Paragraph = styled.p`
  margin-bottom: 5px;
`;

export const Question = styled.p`
  margin-top: 20px;
  margin-bottom: 8px;
`;
